import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { Container, Label } from './styled'

const Timer = props => {
    const { size, background, duration, delayOnComplete, onComplete } = props

    const [counter, setCounter] = useState(duration)

    useEffect(() => {
        if (counter === 0) {
            onComplete()

            setTimeout(() => {
                setCounter(duration)
            }, delayOnComplete*1000)
        } else {
            setTimeout(() => {
                setCounter(counter-1)
            }, 1000)
        }
    }, [counter])

    return <Container isReloading={counter === 0} {...props}>
        
        {counter !== 0
            ? <>
                <Label>{counter}</Label>
                <svg height={size} width={size} transform='rotate(-90)'>
                    <circle cx={size/2} cy={size/2} r={(size/2) - 2} fill={background} />
                    <circle cx={size/2} cy={size/2} r={(size/2) - 2} fill={background} />
                </svg>
            </>
            : <>
                <Label> ... </Label>
                <svg height={size} width={size} transform='rotate(-90)'>
                    <circle cx={size/2} cy={size/2} r={(size/2) - 2} fill={background} />
                </svg>
            </>
        }
    </Container>
}

Timer.propTypes = {
    size: PropTypes.number,
    background: PropTypes.string,
    strokeColor: PropTypes.string,
    strokeWidth: PropTypes.string,
    margin: PropTypes.string,
    duration: PropTypes.number,
    delayOnComplete: PropTypes.number,
    onComplete: PropTypes.func
}

Timer.defaultProps = {
    size: 200,
    background: 'none',
    strokeColor: null,
    strokeWidth: '3px',
    margin: '0',
    duration: 10,
    delayOnComplete: 3,
    onComplete: () => {}
}

export default Timer